import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

/** ```
 * 행사 남은 좌석수 정보 조회
 *   `/event/{evCd}/availability`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = `useCode`;
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event/${evCd}/availability`;
};

/** ```
 * 행사 남은 좌석수 정보 조회
 *   `/event/{evCd}/availability`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const eventAvailabilityAsync = async (evCd: string) => {
	const result = await useConfigureAxios({url: getPath(evCd), method: "GET"});
	return result;
};

/** ```
 * 행사 남은 좌석수 정보 조회
 *   `/event/{evCd}/availability`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventAvailability = (evCd: string, options?: Partial<UseQueryOptions<Response<number>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		throwOnError: false,
		...options,
	});

export default useEventAvailability;
export {getPath, key, eventAvailabilityAsync};
